import { registerLibraryUpload } from "../services/api/editor/background_removal";
import { useEditorStore } from "../state/editorStore";
import { isFallbackClassifyLabel } from "./classifyImageLabel";
import { formatClassifyLabel } from "./formatClassifyLabel";

/** Dedupe Strict-Mode / Dashboard+Editor double register for the same File. */
const libraryUploadInFlight = new WeakMap();
/** Remember taxonomy label per File so Editor can re-apply after BG processing. */
const objectLabelByFile = new WeakMap();

export function getRememberedObjectLabel(file) {
  return file ? objectLabelByFile.get(file) || null : null;
}

export function rememberObjectLabel(file, label) {
  if (!file || !label || isFallbackClassifyLabel(label)) return;
  objectLabelByFile.set(file, label);
}

export function extractUploadClassifyLabel(result) {
  const apiLabel =
    typeof result?.label === "string" ? result.label.trim() : "";
  if (!apiLabel || isFallbackClassifyLabel(apiLabel)) return null;
  return formatClassifyLabel(apiLabel);
}

/** Apply Object / Layers label immediately (safe outside React effects). */
export function applyObjectLayerLabel(label) {
  if (!label || isFallbackClassifyLabel(label)) return;
  useEditorStore.getState().setLayerLabel?.("object", label);
}

/**
 * Persist dashboard/original file to Uploads library (POST /uploads).
 * Same File instance shares one in-flight request. On success, applies the
 * classify label to the Object layer even if the calling effect was cancelled.
 */
export function registerLibraryUploadOnce(token, file) {
  if (!token || !file) {
    return Promise.reject(new Error("token and file required"));
  }
  let pending = libraryUploadInFlight.get(file);
  if (!pending) {
    pending = registerLibraryUpload(token, file)
      .then((result) => {
        const label = extractUploadClassifyLabel(result);
        if (label) {
          rememberObjectLabel(file, label);
          applyObjectLayerLabel(label);
        }
        return result;
      })
      .catch((err) => {
        libraryUploadInFlight.delete(file);
        throw err;
      });
    libraryUploadInFlight.set(file, pending);
  }
  return pending;
}
